import script from "./PasswordChangeView.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordChangeView.vue?vue&type=script&setup=true&lang=js"

import "./PasswordChangeView.vue?vue&type=style&index=0&id=20a001e0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20a001e0"]])

export default __exports__